import { useEffect, useState } from 'react';

/**
 * Are we in the mobile breakpoint? Single source of truth so different
 * components don't drift on what "mobile" means. Used for the rare
 * cases that need a different React tree (e.g. swap a table for cards);
 * most layout changes belong in App.css media queries instead.
 */
export default function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isMobile;
}
